import * as React from 'react';
import PropTypes from 'prop-types';
var SvgActionsFlagHighlightedXsmall = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 13v3H1V2a1 1 0 011-1h13a1.001 1.001 0 01.895 1.447L13.618 7l2.277 4.553A1.001 1.001 0 0115 13H2z"
  }));
});
SvgActionsFlagHighlightedXsmall.defaultProps = {
  height: 16,
  width: 16
};
SvgActionsFlagHighlightedXsmall.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgActionsFlagHighlightedXsmall;